import {
	getApiUrl,
	getUsersIdAvatarPath,
	OrderCallStatus,
	type OrderDetailResponseDto,
} from "Infrastructure/Api/Api";
import { useDateFormat } from "Infrastructure/Utilities/dateFormat";
import { useUserList } from "Settings/User/Api/Query/useUsersListQuery";
import ProfileImg from "Shared/Assets/Images/Profiles/user-1.jpg";
import { PhoneCallback, PhoneDisabled } from "@mui/icons-material";
import { Avatar, Popover, Stack, Tooltip, Typography } from "@mui/material";

type OrderCallsListProps = {
	open: boolean;
	anchorEl: HTMLElement | null;
	onClose: () => void;
	order?: OrderDetailResponseDto;
};

const CallStatusIcon = {
	[OrderCallStatus.answered]: {
		component: <PhoneCallback />,
		color: "success.main",
	},
	[OrderCallStatus.no_answer]: {
		component: <PhoneDisabled />,
		color: "error.main",
	},
};

export function OrderCallsList({
	open,
	anchorEl,
	onClose,
	order,
}: OrderCallsListProps) {
	const { data: users } = useUserList();
	const { formatDateTime } = useDateFormat();

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
		>
			{order?.calls.map((call) => {
				const operator = users?.find(
					(user) => user.id === Number(call.operatorId),
				);
				return (
					<Stack
						key={call.id}
						p={2}
						gap={1}
						direction="row"
						alignItems="center"
					>
						{call.operatorId && (
							<Tooltip title={`${operator?.name} ${operator?.surname}`}>
								<Avatar
									src={
										operator?.avatarFileName
											? `${getApiUrl()}${getUsersIdAvatarPath(Number(call.operatorId))}`
											: ProfileImg
									}
									alt="Profile image"
									sx={{
										width: 24,
										height: 24,
									}}
								/>
							</Tooltip>
						)}
						{call.dateCreated && (
							<Typography variant="body2">
								{formatDateTime(call.dateCreated)}
							</Typography>
						)}
						{call.status && (
							<Typography
								variant="body2"
								color={CallStatusIcon[call.status].color}
							>
								{CallStatusIcon[call.status].component}
							</Typography>
						)}
					</Stack>
				);
			})}
		</Popover>
	);
}
